<template>
  <div :class="{ 'snackbar-mobile': $vuetify.breakpoint.mobile }">
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      :bottom="!$vuetify.breakpoint.mobile"
      :right="!$vuetify.breakpoint.mobile"
      :top="$vuetify.breakpoint.mobile"
      transition="slide-y-transition"
    >
      <v-progress-circular
        v-if="snackbar.loading"
        indeterminate
        color="white"
        size="20"
        class="mr-2"
        width="2"
      ></v-progress-circular
      >{{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("snackbar", ["snackbar"]),
  },
  methods: {
    update() {
      this.$router.push("/update");
      setTimeout(function () {
        location.reload();
      }, 40);
    },
  },
};
</script>
<style>
.snackbar-mobile .v-snack__wrapper {
  margin: 0px !important;
  max-width: 100vw !important;
}
.snackbar-mobile .v-snack {
  display: block !important;
}
.snackbar-mobile .v-sheet.v-snack__wrapper {
  border-radius: 0px !important;
}
</style>